module.exports = __webpack_public_path__ + "assets/images/USD5.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/USD5.png
// module id = 1456
// module chunks = 1